import React, { useState } from "react";
import VideoFeed from "./VideoFeed";

import VideoLesson from "./VideoLessons";

const VideoApp = () => {
  const [currentComponent, setCurrentComponent] = useState("videoFeed");
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const handleViewFullLesson = (videoId) => {
    setSelectedVideoId(videoId);
    setCurrentComponent("fullLesson");
  };

  const handleGoBack = () => {
    setCurrentComponent("videoFeed");
    setSelectedVideoId(null);
  };

  return (
    <div className="h-screen bg-gray-900">
      {currentComponent === "videoFeed" && (
        <VideoFeed onViewFullLesson={handleViewFullLesson} />
      )}
      {currentComponent === "fullLesson" && (
        <VideoLesson videoId={selectedVideoId}  handleGoBack={handleGoBack} />
      )}
    </div>
  );
};

export default VideoApp;
